import { Link } from 'react-router-dom'
import { useCallback } from 'react'
import { useUrlStore } from '@repo/store/useUrlStore'
import { useUserPreferencesStore } from '@repo/store/useUserPreferencesStore'
import PropTypes from 'prop-types'

const defaultMatterPage =
  useUserPreferencesStore.getState().defaultMatterPage || '/case-management/matters/matter-workspace'

export const LinkWithClientMatterNo = ({
  to = defaultMatterPage,
  clientMatterNo,
  stopPropagation,
  onClick,
  appendClientMatterNo = true,
  ...rest
}) => {
  const { navigateWithClientMatterNo, urlEncodeClientMatterNo } = useUrlStore.getState()
  const encodedClientMatterNo = urlEncodeClientMatterNo({ clientMatterNo })

  if (!to.startsWith('/') && !to.startsWith('http')) {
    to = `/${to}`
  }

  const handleClick = useCallback(
    async (event) => {
      if (onClick) onClick(event)
      if (event.defaultPrevented) return

      // Let modifier keys / middle-click behave as normal links
      if (
        event.button !== 0 || // not left click
        event.metaKey ||
        event.altKey ||
        event.ctrlKey ||
        event.shiftKey
      ) {
        return
      }

      event.preventDefault()
      if (stopPropagation) event.stopPropagation()

      navigateWithClientMatterNo({
        route: to,
        clientMatterNo,
        appendClientMatterNo
      })
    },
    [onClick, to, clientMatterNo, navigateWithClientMatterNo, stopPropagation, appendClientMatterNo]
  )

  return <Link to={`${to}/${encodedClientMatterNo}`} onClick={handleClick} {...rest} />
}

LinkWithClientMatterNo.propTypes = {
  to: PropTypes.string,
  clientMatterNo: PropTypes.string.isRequired,
  stopPropagation: PropTypes.bool,
  appendClientMatterNo: PropTypes.bool,
  onClick: PropTypes.func
}
